/**
 * A school code typed BEFORE the learner has an account to attach it to.
 *
 * Sign-in leaves the page (Google popup, or an email confirmation opened in
 * another tab), so the code waits here and is redeemed the moment a session
 * exists. localStorage rather than sessionStorage because the confirmation link
 * lands in a new tab.
 */

const KEY = 'learn.pendingSchoolCode';

export function readPendingSchoolCode(): string {
  try {
    return localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

export function writePendingSchoolCode(code: string): void {
  try {
    if (code.trim()) localStorage.setItem(KEY, code.trim());
    else localStorage.removeItem(KEY);
  } catch {
    // Private windows refuse storage; the learner can still enter the code after signing in.
  }
}

export function clearPendingSchoolCode(): void {
  writePendingSchoolCode('');
}

/** A school can hand out one link: learn.4klabs.ai/learn?school=CODE. */
export function capturePendingSchoolCodeFromUrl(): void {
  const code = new URLSearchParams(window.location.search).get('school');
  if (code) writePendingSchoolCode(code);
}
